import { render } from "./HelpResources.vue?vue&type=template&id=5c751c50&scoped=true&ts=true&lang=pug"
import script from "./HelpResources.vue?vue&type=script&lang=ts"
export * from "./HelpResources.vue?vue&type=script&lang=ts"

import "./HelpResources.vue?vue&type=style&index=0&id=5c751c50&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./HelpResources.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/components/helpresources.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fviews%2FHelpResources.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c751c50"]])

export default __exports__